<template>
  <section class="navigation">
    <el-menu default-active="1" :router="true" class="el-menu-vertical-demo">
      <el-menu-item index="0" :route="{ name: 'spaces' }">
        <span slot="title"><img src="/images/grabe_logo_white.svg" alt="Grabe"></span>
      </el-menu-item>
      <el-menu-item index="0" :route="{ name: 'spaces' }">
        <i class="el-icon-news"></i>
        <span slot="title">Espaces</span>
      </el-menu-item>
      <el-menu-item v-if="space" index="0" :route="{ name: 'editor-entities', params: { spaceId: space.spaceId } }">
        <i class="el-icon-menu"></i>
        <span slot="title">{{ space.name }}</span>
      </el-menu-item>
      <el-menu-item index="0" v-if="$route.params.spaceId" v-for="entity in entities" :key="`nav-${entity.entityId}`"
        :route="{ name: 'editor-contents', params: { spaceId: entity.spaceId, entityId: entity.entityId } }">
          <i class="el-icon-tickets"></i>
          <span slot="title">{{ entity.name }}</span>
      </el-menu-item>
      <el-menu-item index="0" v-if="$route.params.spaceId"
        :route="{ name: 'editor-media', params: { spaceId: $route.params.spaceId, page: 1 } }">
        <i class="el-icon-picture"></i>
        <span slot="title">Médias</span>
      </el-menu-item>
      <el-menu-item index="0" v-if="$route.params.spaceId"
        :route="{ name: 'admin-entities', params: { spaceId: $route.params.spaceId, page: 1 } }">
        <i class="el-icon-news"></i>
        <span slot="title">Modèles</span>
      </el-menu-item>
      <el-menu-item index="/login" @click="logout()">
        <i class="el-icon-circle-close-outline"></i>
        <span slot="title">Se déconnecter</span>
      </el-menu-item>
    </el-menu>
  </section>
</template>

<script>
import api from '@/services/api';
import auth from '@/services/auth';

export default {
  name: 'navigation',
  data() {
    return {
      entities: null,
      space: null,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  watch: {
    '$route.params.spaceId': 'fetchData',
  },
  methods: {
    async fetchData() {
      if (this.$route.params.spaceId) {
        this.space = await api.getSpace(this.$route.params.spaceId);
        this.entities = await api.getEntities(this.$route.params.spaceId);
      }
    },
    logout() {
      auth.logout();
    },
  },
};
</script>

<style lang="sass">
.navigation
  position: fixed
  left: 0
  top: 0
  bottom: 0
  width: 200px
  background: #001861

  .el-menu
    background: transparent
    border: none
    .el-menu-item
      color: white
      text-align: left
      img
        display: block
        margin-top: 1.5rem
        height: 40px
      i
        color: #ff3c48
      a
        color: white
        text-decoration: none
      &.router-link-exact-active
        background: rgba(255,255,255,0.1)
        border-left: 1px solid white
      &:hover, &:focus
        background: rgba(0,0,0,0.1)

</style>
